import React, { useState, useEffect, useCallback } from "react";
import { ArrowUp } from "lucide-react";
import { useLanguage } from "../../../contexts/LanguageContext";
import "./ScrollToTop.css";

export default function ScrollToTop({
  showAt = 400,
  behavior = "smooth",
}) {
  const { lang } = useLanguage();
  const isAr = lang === "ar";
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let ticking = false;

    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          setVisible(window.scrollY > showAt);
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [showAt]);

  const scrollToTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior });
  }, [behavior]);

  return (
    <button
      type="button"
      className={`scroll-to-top ${visible ? "visible" : ""}`}
      onClick={scrollToTop}
      aria-label={isAr ? "العودة لأعلى الصفحة" : "Scroll to top"}
      dir={isAr ? "rtl" : "ltr"}
    >
      <ArrowUp size={22} strokeWidth={2.5} />
    </button>
  );
}